import React from 'react';
import { Stack } from '@hub/stack';
import { StoreListItem } from './store-list-item';
import { jsx as _jsx } from "react/jsx-runtime";
export const ListView = _ref => {
  let {
    centre,
    stores,
    onClick
  } = _ref;
  return /*#__PURE__*/_jsx(Stack, {
    direction: "column",
    "data-id": "visible-stores_list-view_ListView_Stack",
    children: stores.map(store => /*#__PURE__*/_jsx(StoreListItem, {
      centre: centre,
      store: store,
      onClick: e => onClick(e, store),
      "data-id": "visible-stores_list-view_ListView_StoreListItem"
    }, store.id))
  });
};